<template>
  <Modal :active="modalShowMessage" id="modalMessage" @close="modalShowMessage = false" :showCloseButton="false">
    <Column justify="center" :center="true">
      <Spacer bottom="md">
        <Column justify="center" :center="true">
          <Spacer bottom="xs">
            <WebText variant="ui-large" bold="bold" ink="label" data-cy="messagemodalTitle" center="center">{{
              title
            }}</WebText>
          </Spacer>
          <WebText variant="ui-baseline" tag="span" data-cy="messagemodalDescription" :center="true">{{ msg }}</WebText>
        </Column>
      </Spacer>
      <EButton
        variant="primary"
        v-on:click="
          $emit('message-ok');
          modalShowMessage = false;
        "
        type="button"
        data-cy="messagemodalOKbtn"
        >{{ okText }}</EButton
      >
    </Column>
    <div class="row" v-if="!!cancelText">
      <div
        class="col"
        @click="
          $emit('message-cancel');
          modalShowMessage = false;
        "
      >
        <span
          class="volo-small-label qoala-primary-text"
          v-on:click="modalShowMessage = false"
          data-cy="messagemodalCancelbtn"
          style="display: block; margin: 20px 0 10px; text-align:center;"
          >{{ cancelText }}</span
        >
      </div>
    </div>
  </Modal>
</template>

<script>
import { Text as WebText, Button as EButton, Column, Modal, Padder, Spacer } from '@qoala/ui';

export default {
  /* props: {
        title: {
            type: String,
            default: ""
        }
    }, */
  components: {
    EButton,
    WebText,
    Modal,
    Padder,
    Spacer,
    Column
  },
  data() {
    return {
      title: '',
      msg: '',
      okText: 'OK',
      modalShowMessage: false,
      cancelText: ''
    };
  },
  methods: {
    showModal(tittleShow, msgShow, textOk, cancelText) {
      this.title = tittleShow;
      this.msg = msgShow;
      if (textOk) this.okText = textOk;
      this.cancelText = cancelText;
      this.modalShowMessage = true;
    },
    getStatusModal() {
      return this.modalShowMessage;
    }
  }
};
</script>

<style lang="scss" scoped>
.message__desc {
  white-space: pre-wrap;
}
</style>
